import React, { useRef, useState } from 'react'
import './Email.css'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SubjectIcon from '@mui/icons-material/Subject';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import emailjs from '@emailjs/browser';
const Email = () => {
  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    email: '',
    subject: '',
    message: '',
  });
  const form = useRef();

  const sendEmail = (e) => {
    // e.preventDefault();
    // emailjs.sendForm('service_p5ufpmr', 'template_vdkoroz', form.current, 'SZnjQEdlIN3c4GNEB')
    //   .then((result) => {
    //     alert("Message sent successfully")

    //   }, (error) => {
    //     console.log(error);
    //   });

  };
  return (
    <div className="contact-us">
      <div className="email-form">

        <h2 className='email-title'>Contact Us</h2>
        <div className="email-subtitle">
          <span className='subtitle'>Let's build, launch & grow</span>
        </div>
        <form className='form' ref={form} onSubmit={sendEmail}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <div className="input-container">
              <PersonOutlinedIcon style={{ width: '45px', height: '45px', display: 'flex', color: 'grey' }}></PersonOutlinedIcon>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                required
                placeholder='Enter Your Name'
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="contact">Contact</label>
            <div className="input-container">
              <PhoneAndroidOutlinedIcon style={{ width: '45px', height: '45px', display: 'flex', color: 'grey' }}></PhoneAndroidOutlinedIcon>
              <input
                type="text"
                id="contact"
                name="contact"
                value={formData.contact}
                required
                placeholder='Enter Contact Number'
                onChange={(e) =>
                  setFormData({ ...formData, contact: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <div className="input-container">
              <EmailOutlinedIcon style={{ width: '45px', height: '45px', display: 'flex', color: 'grey' }}></EmailOutlinedIcon>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                required
                placeholder='Enter Your Email'
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <div className="input-container">
              <SubjectIcon style={{ width: '45px', height: '45px', display: 'flex', color: 'grey' }}></SubjectIcon>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                required
                placeholder='Enter Your Subject'
                onChange={(e) =>
                  setFormData({ ...formData, subject: e.target.value })
                }
              />
            </div>
          </div>
          {/* <button type="submit">Submit</button> */}
          <div className="form-group form-group-text-area" style={{ marginTop: '20px' }}>
            <label htmlFor="message">Your Message</label>
            <div className="textarea-container">
              <CreateOutlinedIcon style={{ width: '30px', height: '30px', display: 'flex', color: 'grey' }}></CreateOutlinedIcon>
              <textarea
                id="message"
                rows="5"
                name="message"
                value={formData.message}
                required
                placeholder='Type here...'
                onChange={(e) =>
                  setFormData({ ...formData, message: e.target.value })
                }
              />
            </div>
          </div>
          <div className="email-btn">
            <button type="submit" value="Send">Submit</button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Email